import React from 'react';
import { Tag, TagProps } from '@myua/kit';
import { LicenseStatus } from '../../../../general/model';

// Статус-бейдж лицензии файла (MYUA-16456). Готового цветного Tag под enum-статусы
// в assetLab нет, поэтому маппим цвет и подпись вручную (палитра @myua/kit ограничена).
const STATUS_CONFIG: Record<LicenseStatus, { color: TagProps['color']; label: string }> = {
  [LicenseStatus.UnderModeration]: { color: 'orange', label: 'Under moderation' },
  [LicenseStatus.Approved]: { color: 'green', label: 'Approved' },
  [LicenseStatus.Rejected]: { color: 'byzantium', label: 'Rejected' },
};

export const LicenseStatusTag: React.FC<{ status: LicenseStatus }> = ({ status }) => {
  // Неизвестный статус (напр. если бэкенд добавит новый) показываем как есть, без падения.
  const { color, label } = STATUS_CONFIG[status] ?? { color: 'default', label: status };
  return (
    <Tag color={color} style={{ marginRight: 0 }}>
      {label}
    </Tag>
  );
};
